import {ChevronIcon, Grid, Typography} from '@yandex-delivery/blocks'
import {noop} from '@yandex-delivery/utils'
import clsx from 'clsx'

import {classes} from './ToggleTitle.classes'
import type {Props} from './ToggleTitle.types'

export function ToggleTitle({
  title,
  onClick = noop,
  isOpened = false,
  'data-e2e': dataE2e = '',
}: Props): React.ReactElement {
  return (
    <Grid alignItems="center" className={classes.root} data-e2e={dataE2e} onClick={onClick} container>
      <Grid item>
        <Typography className={classes.title} data-e2e="toggle-title-title" group="normal" variant="caption1">
          {title}
        </Typography>
      </Grid>
      <Grid item>
        <ChevronIcon className={clsx(classes.icon, {[classes.opened]: isOpened})} data-e2e="toggle-title-chevron" />
      </Grid>
    </Grid>
  )
}
